import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";

/**
 * Hook that tracks if the current browser tab is active/visible
 * @returns A ref containing whether the tab is currently active
 */
export function useTabActivity() {
  const $ = _c(2);
  const [isTabActive, setIsTabActive] = useState(true);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const handleVisibilityChange = function handleVisibilityChange() {
        setIsTabActive(document.visibilityState === "visible");
      };
      handleVisibilityChange();
      document.addEventListener("visibilitychange", handleVisibilityChange);
      return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isTabActive;
}